import {
  FloatingSection,
  Header,
  Intro,
  NewsWidget,
} from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";

export default function Innovation() {
  return (
    <div>
      <Header
        image={t(routes.innovation, "image")}
        title={t(routes.innovation, "title")}
      >
        <p>
          Manufacturing in the UK, with materials selected from sustainable
          resources, coupled with the multi-million-pound investment in our
          factory, has ensured that we produce a superior-quality product that
          will truly stand the test of time.
        </p>
        <p>
          Thanks to investment from Ballingslöv, our parent company, we are able
          to design new, innovative products and solutions. We can prototype and
          manufacture in-house, thereby offering bespoke solutions when
          required.
        </p>
      </Header>
      <Intro title="World-class manufacturing in the UK">
        <p>
          It's not just our products that set us apart. Combining the team’s
          experience, Paula Rosa Manhattan has many years’ of knowledge
          regarding design, manufacturing, and sourcing, enabling us to
          challenge and better ourselves in every aspect. We are proud to be a
          champion of the finest kitchens and have the internal infrastructure
          required to deliver an exceptional finished product for our clients.
        </p>
      </Intro>
      <FloatingSection
        title={
          <>
            <h3 className="text-xl font-light">Investing in the future</h3>
            <p className="font-medium">
              Our parent company’s investment of over £10 million has enabled
              the integration of new, state-of-the-art technology, new
              machinery, an updated office, a new fleet, and new distribution
              capabilities.
            </p>
          </>
        }
        image="/media/assets/innovation-and-premises-investing-future.jpg"
      >
        <p>
          We engage with many of the world's leading suppliers of componentry
          for kitchens, bedrooms, and bathrooms, enabling us to be ahead of the
          market with new product features. Our design lab allows our customers
          to experiment in real time on colour choice and features, which we are
          then able to quickly convert into realistic CGI for onwards sharing.
        </p>
        <p>
          To keep up – or better still – be ahead, we are not only constantly
          reviewing latest styles; i.e. being ‘on trend’, we can call upon the
          Ballingslov group of companies to share latest fashions, designs and
          colours.
        </p>
      </FloatingSection>
      <section className="container my-20">
        <h3 className="mb-20 border-b pb-4 text-xl font-medium">
          The investment in detail
        </h3>
        <ul className="grid grid-cols-2 gap-10 text-center md:grid-cols-4">
          {[
            [
              "https://d33wubrfki0l68.cloudfront.net/c7832c4ff3e792992023e7aaf3866450c16d4567/fa41a/media-assets-innovation-and-premises-investment-01-f11036e.svg",
              "£8 million",
              "Invested in state-of-the-art technology and machinery",
            ],

            [
              "https://d33wubrfki0l68.cloudfront.net/c07f2084cd97f79db740d1fc80bec4db701327e7/bd017/media-assets-innovation-and-premises-investment-02-f11036e.svg",
              "£2 million",
              "Invested in a new distribution warehouse and office facilities",
            ],

            [
              "https://d33wubrfki0l68.cloudfront.net/754cd743efc4534a06688e4917a39bf23822162a/93902/media-assets-innovation-and-premises-investment-03-f11036e.svg",
              "£1 million",
              "Invested in a brand new fleet of energy efficient Volvo vehicles",
            ],
            [
              "https://d33wubrfki0l68.cloudfront.net/de8101c4833f7d606cb6351249851b10018c8c03/4b180/media-assets-innovation-and-premises-investment-04-f11036e.svg",
              "£0.5 million",
              "Invested in new kitchen range development, showroom and continuous investment in our people.",
            ],
          ].map(([img, k, v]) => (
            <li key={k} className="space-y-2">
              <div
                className="mb-10 aspect-[4/2] bg-contain bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${img})` }}
              />
              <h4 className="text-lg font-semibold">{k}</h4>
              <p className="text-xs sm:text-sm">{v}</p>
            </li>
          ))}
        </ul>
      </section>
      <aside className="grid place-items-center bg-black p-10 text-center text-white">
        <h3 className="text-xl font-light md:text-2xl">
          At the heart of many new homes throughout the UK
        </h3>
        <iframe
          className="aspect-video w-full max-md:mt-2 md:w-2/3"
          src="https://player.vimeo.com/video/278121464?title=0&amp;byline=0&amp;portrait=0"
          allowFullScreen
          data-ready="true"
        />
      </aside>
      <NewsWidget />
    </div>
  );
}
